import { X } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const KSeFPainPoints = () => {
  const { t } = useTranslation();

  const painPoints = [
    { title: t('ksef.pain.item1.title'), description: t('ksef.pain.item1.desc') },
    { title: t('ksef.pain.item2.title'), description: t('ksef.pain.item2.desc') },
    { title: t('ksef.pain.item3.title'), description: t('ksef.pain.item3.desc') },
    { title: t('ksef.pain.item4.title'), description: t('ksef.pain.item4.desc') },
  ];

  return (
    <section aria-labelledby="pain-points-heading" className="py-16 px-6 md:px-8 bg-card">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2
            id="pain-points-heading"
            className="text-3xl md:text-5xl font-semibold mb-4 tracking-tight"
          >
            {t('ksef.pain.heading')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {painPoints.map((point) => (
            <div
              key={point.title}
              className="p-6 lg:p-8 rounded-2xl bg-gradient-to-br from-red-50 to-orange-50/50 border border-red-100 dark:from-red-950/50 dark:to-orange-950/30 dark:border-red-800"
            >
              <div className="flex items-start gap-4">
                <div className="size-10 rounded-xl bg-red-100 dark:bg-red-900/50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <X className="size-5 text-red-500 dark:text-red-400" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">{point.title}</h3>
                  <p className="text-sm text-foreground/70 leading-relaxed">{point.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
